import { LockFilled, SafetyCertificateFilled } from '@ant-design/icons';
import React from 'react';

import { Color, EnumTag } from '../../../components/EnumTag';
import { EmergencyPlan } from '../../../graphql/api/generated';

interface IEmergencyPlanWithIconProps {
  emergencyPlan: EmergencyPlan;
  style?: React.CSSProperties;
}

export const EmergencyPlanWithIcon: React.FC<IEmergencyPlanWithIconProps> = (props) => {
  const { emergencyPlan, style } = props;

  return (
    <EnumTag
      enumValue={emergencyPlan}
      colorMap={{
        [EmergencyPlan.UNLOCKED]: Color.Green,
        [EmergencyPlan.LOCKDOWN]: Color.Orange,
      }}
      iconMap={{
        [EmergencyPlan.UNLOCKED]: <SafetyCertificateFilled />,
        [EmergencyPlan.LOCKDOWN]: <LockFilled />,
      }}
      style={style}
    />
  );
};
